
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'

import COVERAPP from '@/utils/COVERAPP'

import Model from '@/components/Model.vue'

export default defineComponent({
    components: {
        Model
    },
    setup() {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false)//判断是否在App内
        const isLogin = ref<boolean>(false)//判断是否已登录
        const isFromMy = ref<boolean>(false)//判断是否从我的藏品页面过来
        const infoData = ref<any>({})
        const successFlag = ref<boolean>(false)//收藏弹框
        const infoFlag = ref<boolean>(false)
        const payFlag = ref<boolean>(false)//支付框
        const payData = ref<any>({})//支付参数
        const timerResultNum= ref<number>(10)//支付参数
        const cangFlag = ref<boolean>(false)//点击收藏的防爆击
        let timer
        let timerResult
        const timerData = ref<number>(0) //支付倒计时

        // 判断环境：app,登录
        const isLoginApp = ()=>{
            // console.log('进入isLoginApp')
            if(COVERAPP.Attribute.isApp()){
                // console.log('进入isLoginApp111')
                onLogin();
                // console.log('进入isLoginApp222')
                isApp.value = true;
            }else{
                isFromMy.value = COVER.getUrl('from') =='myInfo'? true : false
                isApp.value = false
                getCollectionInfo(false,null,'',false);//单纯拿信息
            } 
        }
        // 判断用户是否登录
        const onLogin = () => {
            // console.log('调桥')
            COVERAPP.Method.GetUser({
                callback: function (user) {
                    user = JSON.parse(user);   
                    // console.log('已经登录，获取到的用户信息',user)        
                    if(user.token){
                        COVERAPP.Method.generateSign(user.token,{
                            callback: function (signData) {
                                signData = JSON.parse(signData);
                                // console.log('获取用户验签',signData);
                                getCollectionInfo(true,signData,user.device_id,false);//单纯拿信息
                            }
                        })
                        isLogin.value = true;
                    }else{
                        getCollectionInfo(true,null,'',false);//单纯拿信息
                        isLogin.value = false;
                    }
                }
            });
        }
        // 获取藏品信息
        const getCollectionInfo = (app,signData,device_id,gocang) => {
            let params;
            if(app && signData){
                params = {
                    token: signData.token,
                    vno:'7.4.0',
                    account:signData.account,
                    sign:signData.sign,
                    timestamp:signData.timestamp,
                    deviceid:device_id,
                    data:JSON.stringify({id: parseInt(COVER.getUrl('id'))})
                }
            }else{
                params = {
                    data:JSON.stringify({id:parseInt(COVER.getUrl('id'))})
                }
            }
           
            _this.proxy.$http('/collection/info', params, 'get').then((data: any) => {
                if (data) {
                    if(data.name && data.name.length>10){
                        data.name = data.name.substring(0,10)
                    }
                    if(data.set_name && data.set_name.length>10){
                        data.set_name = data.set_name.substring(0,10)
                    }
                    infoData.value = data//更新了收藏状态和是否有库存的状态
                    share(data.share || {})
                }else{
                    share({})
                }
                if(!gocang){
                    COVER.pageLoaded()
                }else if(gocang && !infoData.value.is_collect && (infoData.value.has_num || infoData.value.has_order)){//后续有操作且未收藏有库存或有订单，调收藏接口
                    let timestamp = new Date().getTime();
                    // console.log('收藏前判断未收藏且有库存，去收藏',infoData.value.sell_start_time,timestamp,infoData.value.sell_end_time)
                    if(timestamp<infoData.value.sell_end_time && timestamp>infoData.value.sell_start_time){//判断时间
                        // console.log('判断支付infoData1',infoData.value.price,parseFloat(infoData.value.price),infoData.value.price>0)
                        if(infoData.value.price>0){//判断藏品是否需要收费
                            //需要收费 走新逻辑
                            getOrder(signData.token,device_id)
                        }else{
                            //不需要收费 走老逻辑
                            doCollect(signData.token,device_id)
                        }
                    }else if(!(timestamp<infoData.value.sell_end_time)){
                        COVER.toast('该藏品收藏已结束')
                        cangFlag.value = false
                    }else if(!(timestamp>infoData.value.sell_start_time)){
                        COVER.toast('该藏品未到发售时间')
                        cangFlag.value = false
                    }
                    
                }
            }).catch((res: any) => {
                share({})
                if(!gocang){
                    COVER.pageLoaded()
                }else {
                    COVER.toast(res.message || '接口请求失败')
                    cangFlag.value = false
                }
            })               
        }
        //分享
        const share = (data: any) => {
            let sharedata = {
                'title': data.share_title || '封面新闻',
                'link': data.share_url || window.location.href,
                'imgUrl': data.share_img || 'https://wapcdn.thecover.cn/cdn/wap/img/fengmian_logo.png',
                'desc': data.share_brief || ''
            };
            COVER.onshare(sharedata)
        }

        // wap引流
        const goApp = (flag) => {
            downloadApp(flag)
            COVER.track('click', '下载app')

        }
        // 吊起app
        const downloadApp = (flag) => {
            let url = encodeURIComponent(window.location.href)
            COVER.downloadApp(COVER.getUrl('id'),url,flag)
        }

        // app中点击收藏
        const goCang = () => {
            // 埋点-新埋点
            COVER.trackNew('click', 1, COVER.getUrl('id'),parseFloat(infoData.value.price))
            //支付的订单，判断登录、判断是否绑定手机号，登录并绑定手机号才去后续判断
            if(parseFloat(infoData.value.price)>0){
                if(cangFlag.value){//如果已经点击了，不可点
                    return
                }
                cangFlag.value = true
                if(isLogin.value){//判断是否登录 如果已经登录了，拿用户信息
                    COVERAPP.Method.GetUser({
                        callback: function (user) {
                            user = JSON.parse(user);   
                            // console.log('点击收藏后获取到的用户信息',user) 
                            if(user.token && user.mobile && user.mobile.toString().length > 0){//如果用户登录了且有手机号码则去收藏
                                COVERAPP.Method.generateSign(user.token,{
                                    callback: function (signData) {
                                        signData = JSON.parse(signData);
                                        // console.log('点收藏，拿到用户信息后，获取用户验签',signData);
                                        getCollectionInfo(true,signData,user.device_id,true);//拿信息并做判断是否进行收藏
                                    }
                                })
                            }else{//去登录或者去绑定手机号
                                // console.log('点击收藏获取到的用户信息没有token或者没有手机号,去登录')   
                                onGoLoginMobile()  
                            }
                        }
                    });
                }else{//还没有登录，先登录后再判断手机号再收藏
                    onGoLoginMobile()
                }
            }else{//1、不需要支付的订单，走老逻辑，判断登录、已登录后判断 再去判断 收藏状态、藏品库存等状态
                if(isLogin.value){//判断是否登录 如果已经登录了，拿用户信息，拿到了去收藏；如果没有拿到用户信息，再去登录；如果没有登录，也先去登录
                    COVERAPP.Method.GetUser({
                        callback: function (user) {
                            user = JSON.parse(user);   
                            // console.log('点击收藏后获取到的用户信息',user)        
                            if(user.token){
                                COVERAPP.Method.generateSign(user.token,{
                                    callback: function (signData) {
                                        signData = JSON.parse(signData);
                                        // console.log('点收藏，拿到用户信息后，获取用户验签',signData);
                                        getCollectionInfo(true,signData,user.device_id,true);//拿信息并做判断是否进行收藏
                                    }
                                })
                            }else{
                                //  console.log('点击收藏获取到的用户信息没有token,去登录')   
                                onGoLogin()  
                            }
                        }
                    });
                }else{//还没有登录，先登录后收藏
                    onGoLogin()
                }
            }
        }
        // 收藏
        const doCollect = (token,device_id) => {
            // console.log('即将去验签')
            COVERAPP.Method.generateSign(token,{
                callback: function (signData) {
                    signData = JSON.parse(signData);
                    // console.log('获取用户验签2',signData);
                    let params = {
                       token: signData.token,
                       vno:'7.4.0',
                       account:signData.account,
                       sign:signData.sign,
                       timestamp:signData.timestamp,
                       deviceid:device_id,
                       data:JSON.stringify({id: parseInt(COVER.getUrl('id'))})
                    }
                    // console.log('收藏参数',params);
                     _this.proxy.$http('/collection/collect', params
                    , 'get').then((data: any) => {
                        // console.log('收藏返回',data)
                        if (data) {
                            // console.log('收藏成功',data.collection_code,data.collect_value)
                            infoData.value.is_collect = true
                            infoData.value.code = data.collection_code//编号
                            infoData.value.collect_value = data.collect_value//次序
                            // console.log('收藏成功后数据',infoData.value.code,infoData.value.collect_value)
                            successFlag.value = true
                            setTimeout(()=>{
                                successFlag.value=false
                                onLogin();
                            },2000)
                        }
                        
                    }).catch((res) => {
                        COVER.toast(res.message || '接口请求失败')
                    })               
                }
            })
        }
        // 无待支付订单-创建订单拿订单信息   有待支付订单-拿已有订单信息
        const getOrder = (token,device_id) => {
            COVERAPP.Method.generateSign(token,{
                callback: function (signData) {
                    signData = JSON.parse(signData);
                    // console.log('获取用户验签2',signData);
                    let params = {
                       token: signData.token,
                       vno:'8.2.0',
                       account:signData.account,
                       sign:signData.sign,
                       timestamp:signData.timestamp,
                       deviceid:device_id,
                       data:JSON.stringify({collectionId: parseInt(COVER.getUrl('id'))})
                    }
                    // console.log('支付参数',params);
                    _this.proxy.$http('/collectionOrder/withPriceCollection', params, 'get').then((data: any) => {
                        // console.log('支付订单返回',data)
                        // 无待支付订单 
                        if (data) {
                            payFlag.value = true
                            payData.value = data
                            timerData.value = data.payRemainingTime //秒
                            handleTimer()
                        }
                        
                    }).catch((res) => {
                        // console.log('支付订单返回1',res)
                        if(res.status == 605){ //有待支付订单 弹框弹出
                            payFlag.value = true
                            payData.value = res.data
                            timerData.value = res.data.payRemainingTime //秒
                            handleTimer()
                        }else{
                            COVER.toast(res.message || '接口请求失败')
                            cangFlag.value = false
                        }
                    })  
                }
            })             
        }
        // 支付 -调桥
        const pay = ()=>{
            COVERAPP.Method.wxPay({
                type:1,
                data:JSON.stringify({
                    "partnerid":payData.value.partnerId,
                    "prepayid":payData.value.prepayId,
                    "noncestr":payData.value.noncestr,
                    "timestamp":COVERAPP.Attribute.isIOS()?parseInt(payData.value.timestamp):payData.value.timestamp,
                    "package":payData.value.packageValue,
                    "sign":payData.value.sign
                }),
                callback(res: any) {
                    let result = res?JSON.parse(res).result:1;
                    // console.log('桥支付结果',res,result)
                    if(result === 0){//-1 微信未安装 0支付成功 1支付失败 2支付取消
                        // console.log('去拿接口支付结果')
                        _this.proxy.$http('/collectionOrder/getOrderStatusByOrderId', {
                                data:JSON.stringify({orderNumber: payData.value.orderNumber})
                            }, 'get').then((data: any) => { 
                            // console.log('支付结果',data)
                            if(data){
                                if(data.status == 2){//支付成功
                                    // console.log('支付成功')
                                    payFlag.value = false
                                    infoData.value.is_collect = true
                                    cangFlag.value = false
                                    if(data.collectionId && data.collectionNumber){
                                        infoData.value.code = data.collectionNumber//编号
                                        infoData.value.collect_value = data.collectionNumber.split('-')[1]//次序
                                        // console.log('收藏成功后数据',infoData.value.code,infoData.value.collect_value)
                                        successFlag.value = true
                                        setTimeout(()=>{
                                            successFlag.value=false
                                            onLogin();
                                        },2000)
                                    }else{
                                        handleTimerResult()
                                    }
                                }else{
                                    COVER.toast(data.statusDesc || '接口请求失败')
                                    cangFlag.value = false
                                }
                            }else{
                                COVER.toast('接口请求失败')
                                cangFlag.value = false
                            }
                        }).catch((error: any) => {
                            COVER.toast(error.message || '接口请求失败')
                            cangFlag.value = false
                        })
                    }else if(result === -1){
                        COVER.toast('未安装微信')
                        cangFlag.value = false
                    }else if(result=== 1){
                        COVER.toast('支付失败')
                        cangFlag.value = false
                    }
                }
            })
        }
        // 拿成功之后的编号次序结果
        const handleTimerResult = () => {
            timerResult = setInterval(function () {
                timerResultNum.value--;
                _this.proxy.$http('/collectionOrder/getOrderStatusByOrderId', {
                                data:JSON.stringify({orderNumber: payData.value.orderNumber})
                            }, 'get').then((data: any) => { 
                            // console.log('支付结果',data)
                            if(data){
                                if(data.status == 2){//支付成功
                                    // console.log('支付成功')
                                    if(data.collectionId && data.collectionNumber){
                                        infoData.value.code = data.collectionNumber//编号
                                        infoData.value.collect_value = data.collectionNumber.split('-')[1]//次序
                                        // console.log('收藏成功后数据',infoData.value.code,infoData.value.collect_value)
                                        successFlag.value = true
                                        clearInterval(timerResult);
                                        timerResult = null
                                        setTimeout(()=>{
                                            successFlag.value=false
                                            onLogin();
                                        },2000)
                                    }
                                }
                            }
                        })
                if (timerResultNum.value == 0) {
                    clearInterval(timerResult);
                    timerResult = null
                }
            }, 1000);
        }
        // 倒计时
        const handleTimer = () => {
            timer = setInterval(function () {
                timerData.value--;
                if (timerData.value == 0) {
                    clearInterval(timer);
                    timer = null;
                }
            }, 1000);
        }
        // 支付弹框关闭 点取消按钮
        const cancelPay = ()=>{
            payFlag.value = false
            payData.value = {}
            timerData.value = 0 //秒
            cangFlag.value = false
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        }
        //前往登录
        const onGoLogin = ()=>{
            COVERAPP.Method.OpenLogin({ 
                callback:function(user){
                    user = JSON.parse(user);
                    // console.log('点收藏后，先去登录后返回信息',user)  
                    if(user.token){//登录之后再判断再拿一遍用户信息，改变按钮状态
                        COVERAPP.Method.GetUser({
                            callback: function (user1) {
                                user1 = JSON.parse(user1);   
                                // console.log('点击收藏后获取到的用户信息',user1)        
                                if(user1.token){
                                     COVERAPP.Method.generateSign(user1.token,{
                                        callback: function (signData) {
                                            signData = JSON.parse(signData);
                                            // console.log('点收藏，登录后获取用户验签',signData);
                                            getCollectionInfo(true,signData,user1.device_id,true);//拿信息并做判断是否进行收藏
                                        }
                                    })
                                    isLogin.value = true;
                                }
                            }
                        });
                    }else{
                       console.log('点收藏，登录失败')   
                    }
                }
            });
        }
        //前往登录，绑定手机号
        const onGoLoginMobile = ()=>{
            // console.log('调登录并绑定手机号')
            COVERAPP.Method.OpenLogin({ 
                needMobile:'1',
                callback:function(user){
                    user = JSON.parse(user);
                    // console.log('点收藏后，先去登录绑定手机号后返回信息',user)  
                    if(user.token){//登录之后再判断再拿一遍用户信息，改变按钮状态
                        COVERAPP.Method.GetUser({
                            callback: function (user1) {
                                user1 = JSON.parse(user1);   
                                // console.log('点击收藏后获取到的用户信息',user1)        
                                if(user1.token){
                                     COVERAPP.Method.generateSign(user1.token,{
                                        callback: function (signData) {
                                            signData = JSON.parse(signData);
                                            // console.log('点收藏，登录后获取用户验签',signData);
                                            getCollectionInfo(true,signData,user1.device_id,true);//拿信息并做判断是否进行收藏
                                        }
                                    })
                                    isLogin.value = true;
                                }else{
                                    cangFlag.value = false
                                }
                            }
                        });
                    }else{
                    //    console.log('点收藏，登录失败')   
                       cangFlag.value = false
                    }
                }
            });
        }

        // app中跳转藏品列表原生页面
        const goMyCollection = () => {
            // console.log('即将去藏品列表页',{
            //     id:parseInt(COVER.getUrl('id'))
            // })
            // 埋点-新埋点
            COVER.trackNew('click', 2, COVER.getUrl('id'),parseFloat(infoData.value.price))
            COVERAPP.Method.goMyCollection({
                id:parseInt(COVER.getUrl('id'))
            });
        }

        // 打开链上信息
        const openInfo = () => {
            infoFlag.value = !infoFlag.value 
        }

        // 复制
        const copy = (data) => {
            if(!data){
                return;
            }
            // 存储传递过来的数据
            let OrderNumber = data;
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement("input");
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber;
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput);
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select();
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand("Copy");
            // 清空输入框
            newInput.remove();
            COVER.toast('复制成功')
        }

        onMounted(() => {
            isLoginApp ()
            // console.log('进入')
            isApp.value = COVERAPP.Attribute.isApp()
            // 埋点-新埋点
            COVER.trackNew('pageload', 0, COVER.getUrl('id'))
        })

        onBeforeUnmount(() => {
            
        })
        

        return {
            isApp,
            isLogin,
            isFromMy,
            infoData,
            successFlag,
            goApp,
            goCang,
            goMyCollection,
            infoFlag,
            openInfo,
            copy,
            payFlag,
            payData,
            timerData,
            cancelPay,
            pay,
            timerResultNum,
            cangFlag
        }
    }
})
